module.exports = __webpack_public_path__ + "media/images/riders/small/CARINA_CAPPELARI-290c0fe0e6b2f2032c9a575fd1f1d6cc.png";